import { useRef, useState } from 'react'

/**
 * The carousel opens when the content is pulled (or wheeled) down at its top,
 * and closes as soon as the content scrolls. Off while selecting, so a drag
 * that paints a range never also opens it.
 */
export function useCarousel(enabled: boolean) {
  const [open, setOpen] = useState(false)
  const touch = useRef({ y: 0, top: 0 })
  const isOpen = enabled && open
  const scrollProps = {
    onWheel: (e: React.WheelEvent<HTMLElement>) => {
      if (!enabled) return
      if (e.deltaY < -4 && e.currentTarget.scrollTop <= 0 && !open) setOpen(true)
      else if (e.deltaY > 4 && open) setOpen(false)
    },
    onTouchStart: (e: React.TouchEvent<HTMLElement>) => {
      touch.current = { y: e.touches[0]?.clientY ?? 0, top: e.currentTarget.scrollTop }
    },
    onTouchMove: (e: React.TouchEvent<HTMLElement>) => {
      if (!enabled) return
      const dy = (e.touches[0]?.clientY ?? 0) - touch.current.y
      if (touch.current.top <= 0 && dy > 36 && !open) setOpen(true)
      else if (dy < -16 && open) setOpen(false)
    },
    onScroll: (e: React.UIEvent<HTMLElement>) => {
      if (open && e.currentTarget.scrollTop > 24) setOpen(false)
    },
  }
  return { open: isOpen, setOpen, toggle: () => setOpen(!open), scrollProps }
}
